export const filterTemplates = (templates, element) =>
	templates.filter((template) =>
		element.data?.map((d) => d.mail_template_ids._id)?.includes(template.value),
	);
